const initialState = false;

/**
 * replaceButtonReducer: Reducer to handle actions related to the state of the replace button.
 *
 * @param {any} state - The current state of the replace button.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {any} The new state after applying the action.
 */

const replaceButtonReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_REPLACE_BUTTON_STATE":
      return action?.payload;
      break;
    default:
      return state;
  }
}

export default replaceButtonReducer;